export const supplyUnitEnum = {
    FT: 1,
    J: 2,
    L: 3,
    ML: 4,
    T: 5,
    TR: 6,
    U: 7,
};
